export default class ValidationHelper {
  public static checkIfStringIsHexColor(string: string): boolean {
    return /^#([0-9A-F]{3}){1,2}$/i.test(string);
  }

  public static checkIfTargetIsValidLoginRedirectTarget(target: string): boolean {
    return /^((https?):\/\/)?([^.]*\.)?(ringana)(-\w*(-\d*)?)?\.com/i.test(target);
  }

  public static checkSwissSocialSecurityNumber(value: string): boolean {
    const regexSwissSocialSecurityNumberRegex = new RegExp(/([0-9]{3})\.([0-9]{4}\.([0-9]{4}).([0-9]{2}))/);
    return regexSwissSocialSecurityNumberRegex.test(value);
  }

  public static isAlphanumeric(value: string): boolean {
    const isAlphanumericRegex = new RegExp(/^[a-zA-Z0-9]*$/);
    return isAlphanumericRegex.test(value);
  }

  public static isEmail(value: string): boolean {
    const regexEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    return regexEmail.test(value);
  }

  public static isNull(prop: unknown): boolean {
    return prop === null;
  }

  public static isNumber(prop: unknown): boolean {
    return typeof prop === `number`;
  }

  public static isString(prop: unknown): boolean {
    return typeof prop === `string`;
  }

  public static isNumberOrNull(prop: unknown): boolean {
    return this.isNumber(prop) || this.isNull(prop);
  }

  public static isStringOrNull(prop: unknown): boolean {
    return this.isString(prop) || this.isNull(prop);
  }
}
